import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav-container" }
const _hoisted_2 = { class: "container container-fluid" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "navbar-brand"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/main-logo.png",
    alt: "Picado"
  })
], -1)
const _hoisted_4 = {
  class: "collapse navbar-collapse",
  id: "navbarText"
}
const _hoisted_5 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", { class: "navbar-nav flex-row align-items-center text-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary btn-sm rounded-5 px-3 me-2 fw-bold"
  }, "Login / Sign up")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarText",
  "aria-controls": "navbarText",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["navbar fixed-top navbar-expand-lg", _ctx.nav_name])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "pe-2 nav-item",
                key: item.url
              }, [
                (item.url == '/home')
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: item.url,
                      class: _normalizeClass(["nav-link", _ctx.$route.path == item.url || _ctx.$route.name == 'Home'? 'active' : ''])
                    }, _toDisplayString(item.title), 11, _hoisted_6))
                  : (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: item.url,
                      class: _normalizeClass(["nav-link", _ctx.$route.path == item.url || _ctx.$route.matched[0].components.default.name == item.name ? 'active' : ''])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]))
              ]))
            }), 128))
          ])
        ]),
        _hoisted_7,
        _hoisted_8
      ])
    ], 2)
  ]))
}